import React from "react";

import { CardBody } from "components/ui/Card";
import { ListBullets } from "components/ui/Lists";

import { useRoles } from "../../hooks/useRoles";
import { useSlice } from "../../hooks/useSlice";
import { useUser } from "../../hooks/useUser";

export const NoClasses = () => {
  const roles = useRoles();
  const { hasAcademicsTab } = useSlice("myStatus");
  const { current_term: currentTerm } = useUser((user) => user.courses) || {};

  return (
    <CardBody>
      {roles.student && !roles.faculty && (
        <div>
          You are not enrolled in any UC Berkeley classes for {currentTerm}.
        </div>
      )}

      {!roles.student && roles.faculty && hasAcademicsTab && (
        <div>
          <p>You have no classes assigned to you this semester.</p>
          <ListBullets>
            <ul>
              <li>
                Check <a href="/academics">My Academics</a> to see past or
                upcoming semesters.
              </li>
              <li>
                If you have any questions about your teaching assignments,
                please contact your academic department.
              </li>
            </ul>
          </ListBullets>
        </div>
      )}

      {roles.student && roles.faculty && hasAcademicsTab && (
        <div>
          <ListBullets>
            <ul>
              <li>
                Check <a href="/academics">My Academics</a> to see your academic
                history or upcoming semesters.
              </li>
              <li>
                If you still have questions, contact the{" "}
                <a href="http://registrar.berkeley.edu/">
                  Office of the Registrar
                </a>{" "}
                or visit{" "}
                <a href="http://studentcentral.berkeley.edu/">
                  Cal Student Central
                </a>
                .
              </li>
              <li>
                If you have any questions about your teaching assignments,
                please contact your academic department.
              </li>
            </ul>
          </ListBullets>
        </div>
      )}

      {!roles.student && !roles.faculty && (
        <div>
          You are not enrolled in any UC Berkeley classes for {currentTerm}.
        </div>
      )}
    </CardBody>
  );
};

NoClasses.displayName = "NoClasses";
